/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CampoMensa } from './campo-mensa';


export interface ServizioMensaAttributoMappingDTO { 
    id?: string;
    campo_mensa?: CampoMensa;
    attributo_id?: string;
    attributo_chiave?: string;
    version?: number;
}



